export var SopStatusResponse;
(function (SopStatusResponse) {
    SopStatusResponse["AUTHENTICATION_EXPIRED"] = "AuthenticationExpiredException";
    SopStatusResponse["CODE_REDEEM_BLOCKED"] = "CodeRedeemBlockedException";
    SopStatusResponse["VALIDATION_EXCEPTION"] = "ValidationException";
    SopStatusResponse["SHARE_EXPIRED_EXCEPTION"] = "ShareExpiredException";
    SopStatusResponse["CODE_REDEEM_EXPIRED_EXCEPTION"] = "CodeRedeemExpiredException";
})(SopStatusResponse || (SopStatusResponse = {}));
//# sourceMappingURL=sop-status.interface.js.map